// extracted by mini-css-extract-plugin
export default {"fileDropContainer":"UploadVideoInput_fileDropContainer__4sYGn","fileDropHeader":"UploadVideoInput_fileDropHeader__d49dh"};